module.exports = __webpack_public_path__ + "assets/img/kitchen_19.50066ed8.jpg";